import { useState, useEffect } from 'react';
import { FiSearch, FiFilter, FiEye, FiDownload, FiX } from 'react-icons/fi';
import { customQuoteService } from '../../../services/customQuoteService';
import { toast } from 'react-toastify';
import { CustomQuote, CustomQuoteResponse } from '../../../models/customQuote';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { COLORS } from '@/utils/colors';
import { Table } from '@/components';

const ViewRequests = () => {
  const [requests, setRequests] = useState<CustomQuote[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedRequest, setSelectedRequest] = useState<CustomQuote | null>(null);
  const [showModal, setShowModal] = useState(false);

  const StatusBadge = ({ status }: { status: string }) => {
    let bgColor = ""
    let textColor = ""

    switch (status.toLowerCase()) {
      case "completed":
        bgColor = "bg-green-300"
        textColor = "text-black"
        break
      case "approved":
        bgColor = "bg-green-300"
        textColor = "text-black"
        break
      case "pending":
        bgColor = "bg-yellow-300/40"
        textColor = "text-black"
        break
      case "in-progress":
        bgColor = "bg-blue-300"
        textColor = "text-black"
        break
      case "rejected":
        bgColor = "bg-red-300"
        textColor = "text-black"
        break
      default:
        bgColor = "bg-gray-300"
        textColor = "text-black"
    }

    return (
      <span className={`${bgColor} ${textColor} px-2.5 py-1 rounded-md text-[10px] font-black uppercase tracking-wider`}>
        {status ? status.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : ''}
      </span>
    )
  }

  // ${request.status === 'completed' ? 'bg-green-900 text-green-400' :
  //                       request.status === 'pending' ? 'bg-yellow-300/20 text-black' :
  //                         request.status === 'in-progress' ? 'bg-[#152259]/20 text-black' :
  //                           'bg-[#152259]/20 text-black'
  //                       }`}

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      const response: CustomQuoteResponse = await customQuoteService.getQuotes();

      if (response.success && Array.isArray(response.data)) {
        setRequests(response.data);
      } else {
        console.error('Invalid response format:', response);
        toast.error('Failed to fetch requests: Invalid response format');
        setRequests([]);
      }
    } catch (error: any) {
      console.error('Error fetching requests:', error);
      // toast.error(error.message || 'Failed to fetch requests');
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredRequests = requests.filter(request => {
    const matchesSearch =
      request.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      request.projectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      request.email.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus = selectedStatus === 'all' || request.status === selectedStatus;

    return matchesSearch && matchesStatus;
  });



  const orderColumns = [
    { label: 'Company', key: 'company' },
    { label: 'Project', key: 'project' },
    { label: 'Quantity', key: 'quantity' },
    { label: 'Status', key: 'status' },
    { label: 'Date', key: 'date' },
    { label: 'Actions', key: 'actions' },
  ];




  const handleViewRequest = (request: CustomQuote) => {
    setSelectedRequest(request);
    setShowModal(true);
  };

  if (loading) {
    return (
      <div
        style={{ backgroundColor: COLORS.background }}
        className="flex-1  min-h-screen flex items-center justify-center">
        <LoadingSpinner message="Loading dashboard data..." />
      </div>
    );
  }



  return (
    <div style={{ backgroundColor: COLORS.background }}>
      <header className="mb-6 pt-16">
        <h1
          style={{ color: COLORS.darkGray }}
          className="text-2xl md:text-3xl font-bold ">Custom Quote Requests</h1>
        <p
          style={{ color: COLORS.gray }}
          className="text-lg">View and manage your custom quote requests</p>
      </header>

      {/* Search and Filter Section */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="relative flex-1">
          <FiSearch className="absolute left-3 top-1/2 text-gray-400 transform -translate-y-1/2 " />
          <input
            type="text"
            placeholder="Search by company, project, or email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ borderColor: COLORS.primary, color: COLORS.black }}
            className="w-full pl-10 border pr-4 py-2 bg-gray-100 rounded-lg outline-none "
          />
        </div>
        <div className="flex items-center gap-2">
          <FiFilter
            style={{ color: COLORS.black }}
          />
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}

            style={{ borderColor: COLORS.primary, color: COLORS.black }}
            className="w-full sm:w-auto rounded-lg px-4 py-2 focus:outline-none "
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="in-progress">In Progress</option>
            <option value="completed">Completed</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
      </div>

      {/* Requests Table - Desktop View */}
      {/* <div
        style={{ backgroundColor: COLORS.white }}
        className=" mb-6 sm:block  rounded-xl overflow-hidden">

        <div className="overflow-x-auto">
          <table className="w-full min-w-[800px]">
            <thead>
              <tr
                style={{ borderColor: COLORS.border, backgroundColor: COLORS.primary }}
                className="border-b">
                <th
                  style={{ color: COLORS.black }}
                  className="px-6 py-4 text-left text-sm font-medium ">Company</th>
                <th
                  style={{ color: COLORS.black }}
                  className="px-6 py-4 text-left text-sm font-medium">Project</th>
                <th
                  style={{ color: COLORS.black }}
                  className="px-6 py-4 text-left text-sm font-medium">Quantity</th>
                <th
                  style={{ color: COLORS.black }}
                  className="px-6 py-4 text-left text-sm font-medium">Status</th>
                <th
                  style={{ color: COLORS.black }}
                  className="px-6 py-4 text-left text-sm font-medium">Date</th>
                <th
                  style={{ color: COLORS.black }}
                  className="px-6 py-4 text-left text-sm font-medium">Actions</th>
              </tr>
            </thead>


                {filteredRequests.length == 0 ? (
                <div className='w-full bg-red-400'>
                <p style={{color:COLORS.black}} className='w-full text-center '>No Data Found</p>
                </div>
                ) :
            
            <tbody>
              {filteredRequests.map((request) => (
                <tr key={request.id}
                  style={{ borderColor: COLORS.border }}
                  className="border-b ">
                  <td
                    style={{ color: COLORS.black }}
                    className="px-6 py-4">{request.companyName}</td>
                  <td
                    style={{ color: COLORS.black }}
                    className="px-6 py-4">{request.projectName}</td>
                  <td
                    style={{ color: COLORS.black }}
                    className="px-6 py-4">{request.orderQuantity}</td>
                  <td
                    style={{ color: COLORS.black }}
                    className="px-6 py-4">
                    <span className={`px-2 py-1 rounded-full capitalize text-xs ${request.status === 'completed' ? 'bg-green-900 text-green-400' :
                      request.status === 'pending' ? 'bg-yellow-300/20 text-black' :
                        request.status === 'in-progress' ? 'bg-[#152259]/20 text-black' :
                          'bg-[#152259]/20 text-black'
                      }`}>
                      {request.status}
                    </span>
                  </td>
                  <td
                    style={{ color: COLORS.black }}
                    className="px-6 py-4">
                    {new Date(request.createdAt).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => handleViewRequest(request)}
                      className="text-blue-400  flex items-center gap-2"
                    >
                      <FiEye />
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

}
          </table>















        </div>
      </div> */}

      <div
        className="md:block mb-6 bg-[#1a1a1a] rounded-lg overflow-hidden hide-scrollbar">
        <Table
          columns={orderColumns}
          data={filteredRequests.map((request) => ({
            id: request.id,
            company: request.companyName,
            project: request.projectName,
            quantity: request.orderQuantity,
            status: <StatusBadge status={request.status} />,
            date: new Date(request.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
            actions: (
              <button
                onClick={() => handleViewRequest(request)}
                className="text-blue-400  flex items-center gap-2"
              >
                <FiEye />
                View
              </button>
            ),
          }))}
          emptyMessage="No request found."
        />
      </div>

      {/* Contact Information Section */}
      <div
        style={{ backgroundColor: COLORS.white }}
        className=" rounded-xl p-4 sm:p-6">
        <h2
          style={{ color: COLORS.black }}
          className="text-xl font-medium mb-4">Contact Information</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <h3
              style={{ color: COLORS.black }}
              className="text-lg font-medium mb-2">Support</h3>
            <p
              style={{ color: COLORS.black }}
            >Email: contact@obscuramfg.com</p>
            <p
              style={{ color: COLORS.black }}
            >Phone: 828-214-5250</p>
          </div>
          <div>
            <h3
              style={{ color: COLORS.black }}
              className="text-lg font-medium mb-2">Business Hours</h3>
            <p style={{ color: COLORS.black }}>Monday - Friday: 9:00 AM - 5:00 PM EST</p>
            <p style={{ color: COLORS.black }}>Saturday - Sunday: Closed</p>
          </div>
        </div>
      </div>

      {/* View Request Modal */}
      {showModal && selectedRequest && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-md flex items-center justify-center z-50 p-4"
          onClick={() => setShowModal(false)}
        >
          <div
            style={{ backgroundColor: COLORS.background }}
            className="rounded-3xl p-6 sm:p-8 max-w-5xl w-full shadow-2xl max-h-[90vh] overflow-y-auto scrollbar-hide border border-white/20"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-8 border-b border-gray-100 pb-5">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-orange-600 flex items-center justify-center text-white">
                  <FiEye size={20} />
                </div>
                <div>
                  <h2
                    style={{ color: COLORS.black }}
                    className="text-2xl font-black tracking-tight"
                  >
                    Request Details
                  </h2>
                  <p className="text-gray-500 text-xs font-medium uppercase tracking-widest mt-0.5">
                    ID: {selectedRequest.id.split('-')[0]} • {new Date(selectedRequest.createdAt).toLocaleDateString()}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowModal(false)}
                className="p-2.5 bg-gray-50 hover:bg-gray-100 rounded-full transition-all text-gray-400 hover:text-black shadow-sm"
              >
                <FiX size={20} />
              </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Left Column */}
              <div className="space-y-6">
                {/* User Information */}
                <div
                  style={{ backgroundColor: COLORS.white }}
                  className="rounded-2xl p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)] border border-gray-100 transition-shadow hover:shadow-md"
                >
                  <div className="flex items-center gap-2 mb-5 border-b border-gray-50 pb-4">
                    <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: COLORS.primary }}></div>
                    <h3 style={{ color: COLORS.black }} className="text-[11px] font-bold uppercase tracking-[0.15em]">User Contact</h3>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Full Name</p>
                        <p className="font-bold text-gray-900">{selectedRequest?.user?.firstName} {selectedRequest?.user?.lastName}</p>
                      </div>
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">User Email</p>
                        <p className="font-semibold text-gray-900 text-sm">{selectedRequest?.user?.email}</p>
                      </div>
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Phone Number</p>
                        <p className="font-semibold text-gray-900">{selectedRequest?.user?.phone || '-'}</p>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Username</p>
                        <p className="font-bold text-gray-900">@{selectedRequest?.user?.username}</p>
                      </div>
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Address</p>
                        <div className="text-[13px] text-gray-900 font-semibold leading-relaxed">
                          <p>{selectedRequest?.user?.address.street}</p>
                          <p>{selectedRequest?.user?.address.city}, {selectedRequest?.user?.address.state}</p>
                          <p>{selectedRequest?.user?.address.country} {selectedRequest?.user?.address.postalCode}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Files & Assets */}
                <div
                  style={{ backgroundColor: COLORS.white }}
                  className="rounded-2xl p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)] border border-gray-100 transition-shadow hover:shadow-md"
                >
                  <div className="flex items-center gap-2 mb-5 border-b border-gray-50 pb-4">
                    <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: COLORS.primary }}></div>
                    <h3 style={{ color: COLORS.black }} className="text-[11px] font-bold uppercase tracking-[0.15em]">Attached Files</h3>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {selectedRequest?.drillFile ? (
                      <a
                        href={selectedRequest?.drillFile}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-gray-100 transition-all hover:bg-orange-50 hover:border-orange-200"
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center text-orange-600 group-hover:scale-110 transition-transform">
                            <FiDownload size={18} />
                          </div>
                          <div>
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Template</p>
                            <p className="text-xs font-bold text-gray-900 truncate max-w-[120px]">Drill Template</p>
                          </div>
                        </div>
                      </a>
                    ) : (
                      <div className="p-3 bg-gray-50 rounded-xl border border-dashed border-gray-200 flex items-center gap-3 opacity-60">
                        <div className="w-10 h-10 rounded-lg bg-gray-200 flex items-center justify-center text-gray-400">
                          <FiDownload size={18} />
                        </div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">No Drill File</p>
                      </div>
                    )}

                    {selectedRequest?.uvPrintFile ? (
                      <a
                        href={selectedRequest?.uvPrintFile}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-gray-100 transition-all hover:bg-blue-50 hover:border-blue-200"
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 group-hover:scale-110 transition-transform">
                            <FiDownload size={18} />
                          </div>
                          <div>
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Graphics</p>
                            <p className="text-xs font-bold text-gray-900 truncate max-w-[120px]">UV Print File</p>
                          </div>
                        </div>
                      </a>
                    ) : (
                      <div className="p-3 bg-gray-50 rounded-xl border border-dashed border-gray-200 flex items-center gap-3 opacity-60">
                        <div className="w-10 h-10 rounded-lg bg-gray-200 flex items-center justify-center text-gray-400">
                          <FiDownload size={18} />
                        </div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">No UV Print File</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Status & Timeline */}
                <div
                  style={{ backgroundColor: COLORS.white }}
                  className="rounded-2xl p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)] border border-gray-100 transition-shadow hover:shadow-md"
                >
                  <div className="flex items-center gap-2 mb-5 border-b border-gray-50 pb-4">
                    <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: COLORS.primary }}></div>
                    <h3 style={{ color: COLORS.black }} className="text-[11px] font-bold uppercase tracking-[0.15em]">Status & Notes</h3>
                  </div>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Current Status</p>
                      <StatusBadge status={selectedRequest.status} />
                    </div>
                    {selectedRequest.notes && (
                      <div className="p-4 bg-gray-50 rounded-xl border border-gray-100 italic text-[13px] text-gray-700 leading-relaxed">
                        "{selectedRequest.notes}"
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-6">
                {/* Quote details */}
                <div
                  style={{ backgroundColor: COLORS.white }}
                  className="rounded-2xl p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)] border border-gray-100 transition-shadow hover:shadow-md"
                >
                  <div className="flex items-center gap-2 mb-5 border-b border-gray-50 pb-4">
                    <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: COLORS.primary }}></div>
                    <h3 style={{ color: COLORS.black }} className="text-[11px] font-bold uppercase tracking-[0.15em]">Quote Details</h3>
                  </div>
                  <div className="space-y-5">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Company</p>
                        <p className="font-bold text-gray-900">{selectedRequest.companyName}</p>
                      </div>
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Project Name</p>
                        <p className="font-bold text-gray-900">{selectedRequest.projectName}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 border-t border-gray-50 pt-4">
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Quantity</p>
                        <p className="font-black text-2xl text-orange-600">{selectedRequest.orderQuantity}</p>
                      </div>
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Delivery</p>
                        <p className="font-bold text-gray-900 uppercase text-xs tracking-wide bg-gray-100 inline-block px-2 py-0.5 rounded">{selectedRequest.deliveryType}</p>
                      </div>
                    </div>
                    <div className="border-t border-gray-50 pt-4">
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Shipping Address</p>
                      <div className="p-4 bg-gray-50 rounded-xl text-[13px] text-gray-900 font-semibold leading-relaxed whitespace-pre-line border border-gray-100">
                        {selectedRequest.shippingAddress}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Enclosure Configuration */}
                <div
                  style={{ backgroundColor: COLORS.white }}
                  className="rounded-2xl p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)] border border-gray-100 transition-shadow hover:shadow-md"
                >
                  <div className="flex items-center gap-2 mb-5 border-b border-gray-50 pb-4">
                    <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: COLORS.primary }}></div>
                    <h3 style={{ color: COLORS.black }} className="text-[11px] font-bold uppercase tracking-[0.15em]">Enclosure Specs</h3>
                  </div>
                  <div className="space-y-4 text-sm">
                    <div className="flex justify-between items-center pb-3 border-b border-gray-50">
                      <span className="text-gray-400 font-bold text-[10px] uppercase tracking-widest">Base Type</span>
                      <span className="font-bold text-gray-900">{selectedRequest.enclosureType?.name}</span>
                    </div>
                    <div className="flex justify-between items-center pb-3 border-b border-gray-50">
                      <span className="text-gray-400 font-bold text-[10px] uppercase tracking-widest">Dimensions</span>
                      <span className="font-bold text-gray-900">
                        {selectedRequest.enclosureType?.dimensions?.length}x{selectedRequest.enclosureType?.dimensions?.width}x{selectedRequest.enclosureType?.dimensions?.height} {selectedRequest.enclosureType?.dimensions?.unit}
                      </span>
                    </div>
                    <div className="flex justify-between items-center pb-3 border-b border-gray-50">
                      <span className="text-gray-400 font-bold text-[10px] uppercase tracking-widest">Holes / Non-Circular</span>
                      <span className="font-bold text-gray-900">{selectedRequest.drilledHoles} / {selectedRequest.nonCircularHoles}</span>
                    </div>
                    <div className="flex justify-between items-center pb-3 border-b border-gray-50">
                      <span className="text-gray-400 font-bold text-[10px] uppercase tracking-widest">Faces To Drill/Print</span>
                      <span className="font-bold text-gray-900">{selectedRequest.facesToDrill} / {selectedRequest.uvPrintFaces}</span>
                    </div>
                    <div className="grid grid-cols-2 gap-2 pt-1">
                      <div className={`p-2 rounded-lg text-center font-bold text-[10px] uppercase tracking-widest ${selectedRequest.isCustomEnclosure ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-400'}`}>
                        Custom Type
                      </div>
                      <div className={`p-2 rounded-lg text-center font-bold text-[10px] uppercase tracking-widest ${selectedRequest.masking ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-400'}`}>
                        Masking Req.
                      </div>
                    </div>
                  </div>
                </div>

                {/* Powder Coating (if any) */}
                {selectedRequest.powderCoating && selectedRequest.powderCoating.length > 0 && (
                  <div
                    style={{ backgroundColor: COLORS.white }}
                    className="rounded-2xl p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)] border border-gray-100 transition-shadow hover:shadow-md"
                  >
                    <div className="flex items-center gap-2 mb-5 border-b border-gray-50 pb-4">
                      <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: COLORS.primary }}></div>
                      <h3 style={{ color: COLORS.black }} className="text-[11px] font-bold uppercase tracking-[0.15em]">Finishing</h3>
                    </div>
                    <div className="space-y-4">
                      {selectedRequest.powderCoating.map((coating, idx) => (
                        <div key={idx} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-gray-100">
                          <div>
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">{coating.itemNumber}</p>
                            <p className="text-xs font-bold text-gray-900">{coating.name}</p>
                          </div>
                          {coating.colorUrl && (
                            <a href={coating.colorUrl} target="_blank" rel="noopener noreferrer" className="p-2 bg-white text-orange-600 rounded-lg hover:bg-orange-600 hover:text-white transition-all shadow-sm border border-gray-100">
                              <FiEye size={16} />
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Modal Footer */}
            <div className="mt-8 pt-6 border-t border-gray-100 flex justify-end gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="px-8 py-3 bg-gray-100 hover:bg-gray-200 text-gray-900 font-bold rounded-xl transition-all shadow-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewRequests; 